import { InputLabel, InputLabelProps } from '@mui/material'
import { FC } from 'react'

interface MolsonInputLabelProps extends InputLabelProps {
  dataTestId?: string
}

export const MolsonInputLabel: FC<MolsonInputLabelProps> = ({
  dataTestId,
  children,
  ...props
}) => {
  return (
    <InputLabel data-testid={dataTestId} {...props}>
      {children}
    </InputLabel>
  )
}
